import React, { useState, useEffect } from "react";
import { FaRegComments } from "react-icons/fa";
import { GrResources } from "react-icons/gr";
import { HiOutlineChartSquareBar } from "react-icons/hi";
import { MdOutlineGroups3, MdOutlinePendingActions } from "react-icons/md";
import Toggle from "react-toggle";
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import axios from "../../../axios";
import { checkValidationOfModule } from "../../../utils/constants";
import * as url from "../../../utils/url";
import { toastContainer } from "../../../utils/toast";
import { deepClone } from "../../../utils/copyObject";

export default function NotificationPrefsComponent({
  currentUser,
  organization,
  member,
  user,
  profileEditSuccsess,
  updateCurrentuser,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [preferences, setPreferences] = useState();

  useEffect(() => {
    setPreferences(deepClone(currentUser.notificationPreferences));
  }, [currentUser]);

  const checkUserPermission = (field) => {
    if (currentUser._id == user.profile._id) {
      return true;
    }
    return false;
  };

  const updateNotificationPreference = (module, value) => {
    const prefs = { ...preferences };

    if (prefs[module]) {
      prefs[module].isDisabled = !value;
      prefs[module].date = new Date();
    }

    setPreferences(prefs);
  };

  const handleSave = () => {
    axios
      .post(url.updateNotificationPrefs, {
        userId: currentUser._id,
        data: preferences,
      })
      .then(({ data }) => {
        if (data.data) {
          profileEditSuccsess(preferences);
          updateCurrentuser("notificationPreferences", preferences);
          toastContainer("Preferences saved succesfully", "success");
          setModalOpen(false)
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const prefsChanged = () => {
    const oldPrefs = { ...currentUser.notificationPreferences };
    const newPrefs = { ...preferences };
    let changed = false;

    for (const key in newPrefs) {
      if (Object.hasOwnProperty.call(newPrefs, key)) {
        const element = newPrefs[key];

        if (element && oldPrefs[key]) {
          console.log({ element, k: oldPrefs[key] });
          if (element.isDisabled == oldPrefs[key].isDisabled) {
          } else {
            changed = true;
          }
        }
      }
    }

    return changed;
  };
  return (
    <div className="profile-notification-prefs">
      {/* {checkUserPermission("notificationPreferences") ? (
        <Button
          size="sm"
          color="danger"
          outline
          onClick={() => {
            setModalOpen(true);
          }}
        >
          Notification Preferences
        </Button>
      ) : (
        ""
      )} */}

      {modalOpen && (
        <Modal isOpen={modalOpen} className="notify_prefs_modal">
          <ModalHeader
            toggle={() => {
              setModalOpen(false);
            }}
          >
            {" "}
            Notification Preferences
          </ModalHeader>

          <ModalBody>
            {organization &&
            currentUser &&
            preferences &&
            checkUserPermission("notificationPreferences") ? (
              <div className="my-3 notification-prefs-container">
                {/* <i
                  className={"flaticon-edit singleTaskIconClass"}
                  style={{ color: "#777777" }}
                />
                <span className="singleTaskDesTxt">
                  Email Notification Preferences
                </span> */}

                <div>
                  {checkValidationOfModule(
                    organization,
                    organization.isCultureApp
                  ) && preferences.cultureApp ? (
                    <div className="d-flex align-items-center my-3">
                      <Label className="mb-0 w-300px">
                        <FaRegComments className="mr-2" /> Culture App
                      </Label>
                      <Toggle
                        checked={!preferences.cultureApp.isDisabled}
                        icons={false}
                        className="ml-2"
                        onChange={(e) => {
                          updateNotificationPreference(
                            "cultureApp",
                            e.target.checked
                          );
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {checkValidationOfModule(
                    organization,
                    organization.isGroups
                  ) && preferences.groups ? (
                    <div className="d-flex align-items-center my-3">
                      <Label className="mb-0 w-300px">
                        <MdOutlineGroups3 className="mr-2" />
                        Groups
                      </Label>
                      <Toggle
                        checked={!preferences.groups.isDisabled}
                        icons={false}
                        className="ml-2"
                        onChange={(e) => {
                          updateNotificationPreference(
                            "groups",
                            e.target.checked
                          );
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {checkValidationOfModule(
                    organization,
                    organization.isPlanning
                  ) && preferences.planning ? (
                    <div className="d-flex align-items-center my-3">
                      <Label className="mb-0 w-300px">
                        <MdOutlinePendingActions className="mr-2" />
                        Planning
                      </Label>
                      <Toggle
                        checked={!preferences.planning.isDisabled}
                        icons={false}
                        className="ml-2"
                        onChange={(e) => {
                          updateNotificationPreference(
                            "planning",
                            e.target.checked
                          );
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {checkValidationOfModule(
                    organization,
                    organization.isAnalytics
                  ) && preferences.analytics ? (
                    <div className="d-flex align-items-center my-3">
                      <Label className="mb-0 w-300px">
                        <HiOutlineChartSquareBar className="mr-2" />
                        Analytics
                      </Label>
                      <Toggle
                        checked={!preferences.analytics.isDisabled}
                        icons={false}
                        className="ml-2"
                        onChange={(e) => {
                          updateNotificationPreference(
                            "analytics",
                            e.target.checked
                          );
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {checkValidationOfModule(
                    organization,
                    organization.isToolkit
                  ) && preferences.resources ? (
                    <div className="d-flex align-items-center my-3">
                      <Label className="mb-0 w-300px">
                        <GrResources className="mr-2" />
                        Resources
                      </Label>
                      <Toggle
                        checked={!preferences.resources.isDisabled}
                        icons={false}
                        className="ml-2"
                        onChange={(e) => {
                          updateNotificationPreference(
                            "resources",
                            e.target.checked
                          );
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ) : null}
          </ModalBody>

          <ModalFooter>
            <Button
              disabled={!prefsChanged()}
              color="primary"
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              onClick={() => {
                setModalOpen(false);
              }}
            >
              Close
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </div>
  );
}
